
import { mapState } from "vuex";
import Storage from "@/utils/storage";
import { getInvite, getActivity, getReceive } from "@/api/sharefission";
import { getQueryValue } from "@/utils/index";
import MobilePhoneLogin from "@/components/forms/MobilePhoneLogin";
import EmailLogin from "@/components/forms/emailLogin";
import EmailRegister from "@/components/forms/emailRegister";
import "@/utils/modalManager";
import {    Header,    Dropdown,    DropdownMenu,    DropdownItem,    Button,} from "apower-ui";
import "@/styles/components/account-modal.scss";
import "@/styles/pages/shareFission.scss";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            



const components = [Header, Dropdown, DropdownMenu, DropdownItem, Button];

components.forEach((component) => {
    Vue.component(component.name, component);
});

new Vue({
    components: {
        MobilePhoneLogin,
        EmailLogin,
        EmailRegister,
    },
    data() {
        return {
            showRule: false,
            copyOk: false,
            countDown: 1,
            activityData: {
                content: {
                    description: "",
                    first_image: "",
                    right_detail: "",
                    rights_and_images: [],
                },
                redirect: "",
                // "style": 10,
                link: "",
                valid_time: "",
            },
            inviteNum: 0,
            showInvite: false,
            page: "A",
            nickname: "",
            receive_type: 9, //初
            lang: "en",
            showLoginDialog: false,
            type: '',
        };
    },
    created() {
        this.initActivity();
        this.getInviteData();
    },
    methods: {
        showRuleWin() {
            this.showRule = !this.showRule;
        },
        handleCommand(command) {
            if (command === "logout") {
                this.$store.dispatch("Logout");
            }
        },
       
         
        // showAccountDialog(type) {
        //     this.showLoginDialog = true
        //     this.$showModal(
        //         () => ({
        //             component: import (
        //                 /* webpackPrefetch: true */
        //                 /*  webpackChunkName: "Account" */
        //                 `@/components/Account.vue`
        //             ),
        //         }), {
        //             width: "400px",
        //             height: "500px",
        //         }, {
        //             successCallback: () => {
        //                 this.$hideModal("Account");
        //                 if (type == "copy") {
        //                     this.copySharelink();
        //                 }
        //                 if (type != "receiveVip") {
        //                     this.getInviteData();
        //                 }
        //                 if (type == "receiveVip") {
        //                     this.receiveVip();
        //                 }
        //             },
        //         },
        //         "Account"
        //     );
        // },
        initActivity() {
            const user_id = getQueryValue("user_id");
            this.nickname = decodeURIComponent(getQueryValue("nickname"));
            if (user_id && this.nickname) {
                this.page = "B";
            }
            const postData = {
                activity_id: parseInt(getQueryValue("activity_id")),
                lang: getQueryValue("lang") || "en",
            };
            getActivity(postData)
                .then((res) => {
                    this.activityData = res.data;
                    this.getTimeDown(res.data.valid_time);
                })
                .catch((err) => {
                    // this.error = true;
                    console.log(err);
                })
                .finally(() => {
                    // this.loading = false;
                });
        },
        getInviteData() {
            const userInfo = Storage.get("userInfo");
            if (userInfo) {
                const postData = {
                    user_id: userInfo.user_id,
                    activity_id: parseInt(getQueryValue("activity_id")),
                };
                getInvite(postData)
                    .then((res) => {
                        this.inviteNum = res.data.count;
                        if (res.data.count >= 1) {
                            this.showInvite = true;
                        }
                    })
                    .catch((err) => {
                        // this.error = true;
                        console.log(err);
                    })
                    .finally(() => {
                        // this.loading = false;
                    });
            }
        },
        getTimeDown(seconds) {
            if (seconds > 0) {
                seconds--;
                let that = this;
                setTimeout(function() {
                    that.getTimeDown(seconds);
                }, 1000);
                // console.log(seconds)
            } else {
                this.countDown = 0;
                this.receive_type = 3;
            }
        },
     
       

        copyLink() {
            const userInfo = Storage.get("userInfo");
            if (userInfo) {
                this.copySharelink();
            } else {
                this.showAccountDialog("copy");
            }
        },
        hideAccountDialog() {
            this.showLoginDialog = false
        },
        showAccountDialog(type) {
            this.showLoginDialog = true
            if(type){
                this.type = type
            }
           },
        loginSuccess(){
            this.showLoginDialog = false
            if (this.type == "copy") {
                this.copySharelink();
            }
            this.getInviteData();
        },
        delQueStr(
            url,
            ref //删除参数值
        ) {
            var str = "";

            if (url.indexOf("?") != -1) str = url.substr(url.indexOf("?") + 1);
            else return url;
            var arr = "";
            var returnurl = "";
            if (str.indexOf("&") != -1) {
                arr = str.split("&");
                for (var i in arr) {
                    if (arr[i].split("=")[0] != ref) {
                        returnurl =
                            returnurl +
                            arr[i].split("=")[0] +
                            "=" +
                            arr[i].split("=")[1] +
                            "&";
                    }
                }
                return (
                    url.substr(0, url.indexOf("?")) +
                    "?" +
                    returnurl.substr(0, returnurl.length - 1)
                );
            } else {
                arr = str.split("=");
                if (arr[0] == ref) return url.substr(0, url.indexOf("?"));
                else return url;
            }
        },
        copySharelink() {
            let userInfo = Storage.get("userInfo");
            let winUrl = this.delQueStr(window.location.href, "user_id");
            winUrl = this.delQueStr(winUrl, "nickname");
            this.$refs.shareLink.value =
                winUrl +
                "&nickname=" +
                encodeURIComponent(userInfo.nickname) +
                "&user_id=" +
                userInfo.user_id;
            this.$refs.shareLink.select();
            document.execCommand("Copy");
            if (document.execCommand("Copy")) {
                document.execCommand("Copy");
                this.copyOk = true;
                setTimeout(() => {
                    this.copyOk = false;
                }, 1000);
            }
        },
        closeReceiveWin() {
            this.receive_type = 9;
        },
        gotoShare() {
            this.page = "A";
            this.receive_type = 9;
        },
        // 成功后的回调
        onSuccess() {
            if (this.countDown == 0) {
                this.receive_type = 3; //活动结束
                return;
            }
            this.receiveVip();
        },
        receiveVip() {
            // let userInfo = Storage.get("userInfo");
            // if(userInfo && Date.now() - userInfo.created_at * 1000 > 1*60*60*1000){
            //   this.receive_type = 0//已经注册
            //   return
            // }
            const postData = {
                user_id: getQueryValue("user_id"),
                activity_id: parseInt(getQueryValue("activity_id")),
            };
            getReceive(postData)
                .then(() => {
                    this.receive_type = 1;
                })
                .catch((err) => {
                    // this.error = true;
                    if (err.status == -101) {
                        this.receive_type = 0; //已经注册
                    }
                    console.log(err);
                })
                .finally(() => {
                    // this.loading = false;
                });
        },
    },
    computed: {
        ...mapState({
            identityToken: (state) => state.user ?.identityToken,
            userInfo: (state) => state.user ?.userInfo,
        }),
    },
}).$mount("#app");
          })
        